"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../icons");
var index_1 = require("../../../illustrations/index");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var variables_1 = require("../../../style/variables");
var FeaturedIcon_1 = __importDefault(require("../FeaturedIcon"));
var react_2 = __importDefault(require("react"));
var illustrationMap = {
    ApplyFilter: index_1.ApplyFilter,
    NoData: index_1.NoData,
    ResultNotFound: index_1.ResultNotFound,
    Status404: index_1.Status404,
};
var EmptyStateTitle = function (props) {
    switch (props.level) {
        case 'comp':
        case 'widget':
            return (react_1.jsx(Text_1.default.Title, { size: props.level === 'widget' ? 'lg' : 'default', color: "var(" + (props.actionable ? variables_1.TextColor.HEAD : variables_1.TextColor.SECONDARY) + ")" }, props.children));
        case 'page':
            return (react_1.jsx(Text_1.default.Heading, { size: "h5", color: "var(" + variables_1.TextColor.HEAD + ")" }, props.children));
    }
};
var EmptyStateDescription = function (props) {
    switch (props.level) {
        case 'comp':
        case 'widget':
            return (react_1.jsx(Text_1.default.Body, { size: props.level === 'widget' ? 'default' : 'sm', color: "var(" + (props.actionable ? variables_1.TextColor.DEFAULT : variables_1.TextColor.SECONDARY) + ")" }, props.children));
        case 'page':
            return (react_1.jsx(Text_1.default.Body, { size: "md", color: "var(" + variables_1.TextColor.DEFAULT + ")" }, props.children));
    }
};
var styles = {
    centerText: react_1.css({
        textAlign: 'center',
    }),
};
var EmptyState = function (props) {
    var renderedIllustration;
    if (typeof props.level === 'object') {
        var Illustration = illustrationMap[props.level.illustration];
        renderedIllustration = react_1.jsx(Illustration, null);
    }
    if (props.v6) {
        if (props.level === 'page') {
            renderedIllustration = react_1.jsx(index_1.PrimaryIllustration, { type: props.illustration });
        }
        else {
            renderedIllustration = (react_1.jsx(index_1.SecondaryIllustration, { type: props.illustration, size: props.level === 'comp' ? 'sm' : 'md', actionable: props.actionable }));
        }
    }
    var centered = props.level === 'component'
        || (typeof props.level === 'object' && props.level.position === 'center')
        || (props.v6 && (props.level === 'comp'
            || props.level === 'widget'
            || (props.level === 'page' && props.orientation === 'vertical')));
    return (react_1.jsx(layout_1.Flex, { direction: centered ? 'column' : 'row', alignItems: "center", justifyContent: "center", gap: props.level === 'component' ? 12 : 32, className: centered ? 'py5' : '' },
        renderedIllustration ? (renderedIllustration) : (react_1.jsx(FeaturedIcon_1.default, { icon: props.featuredIcon || icons_1.SearchSm, size: "lg", theme: "light-circle-outline", color: "Gray" })),
        react_1.jsx(layout_1.Flex, { direction: "column", alignItems: centered ? 'center' : 'flex-start', gap: props.level === 'component' ? 20 : 24 },
            react_1.jsx(layout_1.Flex, { direction: "column", gap: 8, css: centered ? styles.centerText : undefined }, props.v6 ? (react_1.jsx(react_2.default.Fragment, null,
                react_1.jsx(EmptyStateTitle, __assign({}, props), props.title),
                props.description ? (react_1.jsx(EmptyStateDescription, __assign({}, props), props.description)) : null)) : (react_1.jsx(react_2.default.Fragment, null,
                react_1.jsx(Text_1.default.Heading, { size: "h5", color: "var(" + variables_1.TextColor.HEAD + ")" }, props.title),
                props.description ? (react_1.jsx(Text_1.default.Body, { size: "md", color: "var(" + variables_1.TextColor.DEFAULT + ")" }, props.description)) : null))),
            props.children)));
};
exports.default = EmptyState;
